import React from 'react';

const Top2Shape = ({ className }) => {
  return (
    <svg
      className={className}
      width="538"
      height="284"
      viewBox="0 0 538 284"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M235 222.955C99.2307 178.766 0 121.5 0 0L205.983 -3.12733e-05C329.466 -5.89272e-05 438.19 -8.32759e-05 470.5 0C546.206 0.000195126 522.167 71.9548 523 109.955C526.65 154.361 559.566 264.818 513 283.955C470.5 283.955 341 257.455 235 222.955Z"
        fill="white"
      />
    </svg>
  );
};

export default Top2Shape;
